<div class="modal-content">
  <apm-section-title title="{{ 445128 | apmTranslate }}"></apm-section-title>

  <div class="d-block quote-selection-height" *ngIf="projectQuotes().length; else noQuotes">
    <div
      class="w-100 shadow hover-shadow cursor-pointer mt-2 text-md py-4 ps-3 position-relative"
      *ngFor="let q of projectQuotes()"
      (click)="quoteSelected(q)"
    >
      <div class="selected" *ngIf="selectedSelection()?.details?.uuid === q.details.uuid"></div>
      <span>{{ q?.details?.title }}</span>
    </div>
  </div>
  <div class="d-flex float-end mt-3">
    <apm-button class="ms-1" [disabled]="!this.selectedSelection()" (click)="this.selectedSelection() ? save() : null">
      {{ '444682' | apmTranslate }}
    </apm-button>
  </div>
  <ng-template #noQuotes>
    <div class="apm-card w-100 px-2 py-4 shadow cursor-pointer mt-2 text-md">
      <span>{{ '445224' | apmTranslate }}</span>
    </div>
  </ng-template>
</div>
